import React, { memo } from 'react';
import Transition from './Transition';

const FadeTransition = memo(({ children, ...otherProps }) => (
    <Transition {...otherProps}>{children}</Transition>
));

export default FadeTransition;
